import { useEffect, useState } from "react";
import ProfileService from "../../../../../services/Profile";

export default function SubscribedPackages() {
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(false);

    async function getSubscribedPackages() {
        try {
            setLoading(true);

            const res = await ProfileService.getMySubscribedSignals();

            console.log("Subscribed Packages:", res.data);

            if (res?.status === 200) {
                setPackages(res.data?.data || []);
            }
        } catch (error) {
            console.error("Get subscribed packages error:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getSubscribedPackages();
    }, []);

    if (loading) {
        return <p className="text-center text-gray-500 py-6">Loading...</p>;
    }

    if (!packages.length) {
        return (
            <p className="text-center text-gray-500 py-6">
                You haven't subscribed to any packages yet.
            </p>
        );
    }

    return (
        <div className="flex flex-col gap-3">
            {packages.map((item) => (
                <div
                    key={item._id}
                    className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4"
                >
                    {JSON.stringify(item.populate)}
                </div>
            ))}
        </div>
    );
}